// extracted by mini-css-extract-plugin
export default {"icon":"app-button-module--icon--bea52"};